import { useSelector } from 'react-redux';

const useWebSocketConnection = () => {
  const { websocket: { host } } = useSelector(({ websocket }) => websocket);
  return { host };
};

export default {
  useWebSocketConnection,
};
